import React, { useState, useEffect } from 'react';

import VerifyFunding from '../VerifyFunding/container';
import Complete from '../DDRComplete/container';
import { PostregOptions, Step } from './types';
import { useApp } from '../../state/app';

const POSTREG_ORDER: PostregOptions[] = [
  PostregOptions.VERIFY_FUNDING,
  PostregOptions.COMPLETE
];

interface Props {
  app: any;
  user: any;
  toggles: any;
  resolvesErrorId?: string;
}

const PostReg = (props: Props) => {
  const [stepNumber, setStepNumber] = useState(0);
  const [renderedComponent, setRenderedComponent] = useState<
    JSX.Element | undefined
  >();

  const { needsVerification, skippedVerification, answers } = useApp();

  const postregSteps: { [key in PostregOptions]: Step } = {
    VERIFY_FUNDING: {
      component: <VerifyFunding resolvesErrorId={props.resolvesErrorId} />,
      roles: ['parent'],
      shouldShow: () => needsVerification && !skippedVerification
    },

    COMPLETE: {
      component: <Complete />,
      roles: ['parent', 'child', 'approver'],
      shouldShow: () => true
    }
  };

  useEffect(() => {
    const currentStep = postregSteps[POSTREG_ORDER[stepNumber]];
    const shouldShow =
      answers &&
      currentStep.roles.includes(answers.setRole) &&
      currentStep.shouldShow();

    if (shouldShow) {
      setRenderedComponent(postregSteps[POSTREG_ORDER[stepNumber]].component);
    } else {
      setStepNumber(stepNumber + 1);
    }
  }, [needsVerification, skippedVerification, stepNumber]);

  return renderedComponent || <div />;
};

export default PostReg;
